module.exports = __webpack_public_path__ + "static/media/llanta-inspecciones-vencidas.d5cbd8e5.svg";